module.exports = __webpack_public_path__ + "static/media/lookcourse.76b72ff7.png";